import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
  defaultTypography,
  genPageTheme,
  pageTheme,
} from '@backstage/theme';

export const colors = {
  primary: '#674cff',
  black: '#1e1405',
  cream: '#f7efe2',
  blue: '#0b6fc1',
  red: '#d5172f',
  green: '#287a4d',
  orange: '#ec7346',

  swaggerBlue: '#61affe',
  swaggerGreen: '#49cc90',
  swaggerOrange: '#fca130',

  primaryHover: '#4c32df',
} as const;

export const corelogicTheme = createUnifiedTheme({
  fontFamily: 'Poppins',
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 0,
          boxShadow: 'none',
        },
        contained: {
          boxShadow: 'none',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          '& th': {
            color: colors.black,
            fontWeight: 600,
            border: '1px solid rgba(0, 0, 0, 0.07)',
          },
          '& td': {
            border: '1px solid rgba(0, 0, 0, 0.07)',
            lineHeight: 1.375,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardWarning: {
          backgroundColor: '#fcdd83',
          color: '#333333',
        },
        standardError: {
          backgroundColor: '#d4182f',
          color: 'white',
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: () => ({
          height: '100%',
        }),
      },
    },
  },
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: colors.primary,
      },
      secondary: {
        main: colors.primary,
      },
      text: {
        primary: colors.black,
      },
      error: {
        main: colors.red,
      },
    },
    typography: {
      ...defaultTypography,
      htmlFontSize: 16,
      fontFamily: 'Poppins',
    },
  }),
  pageTheme: {
    // Overwrite all default backstage page themes' color
    ...Object.keys(pageTheme).reduce((acc, key) => {
      acc[key] = genPageTheme({
        colors: [colors.black],
        shape: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="200" height="100" fill="rgb(30, 20, 5)" /></svg>');`,
      });

      return acc;
    }, {} as typeof pageTheme),
  },
});
